import React from "react";
import LoadingButton from "../../components/common/LoadingButton";

/**
 * Company OIDC SSO (Okta / Entra) — full-page redirect to the API start URL.
 */
export default function CompanySsoButton({
  onClick,
  loading = false,
  disabled = false,
  label = "Sign in with company SSO",
  loadingLabel = "Redirecting…",
}) {
  return (
    <LoadingButton
      type="button"
      onClick={onClick}
      loading={loading}
      loadingLabel={loadingLabel}
      disabled={disabled}
      className="flex w-full items-center justify-center gap-2 rounded-lg border border-slate-300 bg-white px-4 py-2.5 text-sm font-medium text-slate-800 shadow-sm hover:bg-slate-50 disabled:opacity-50"
    >
      <BuildingGlyph />
      {label}
    </LoadingButton>
  );
}

function BuildingGlyph() {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      aria-hidden="true"
    >
      <path d="M3 21h18" />
      <path d="M5 21V7l7-4 7 4v14" />
      <path d="M9 21v-6h6v6" />
      <path d="M9 10h.01M15 10h.01M9 14h.01M15 14h.01" />
    </svg>
  );
}
